// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../font/Urbanist-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../font/Urbanist-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../font/Urbanist-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../font/Urbanist-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./../font/Urbanist-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../font/Urbanist-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../font/NotoSansKR-Thin.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./../font/NotoSansKR-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./../font/NotoSansKR-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./../font/NotoSansKR-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./../font/NotoSansKR-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./../font/NotoSansKR-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./../font/NotoSansKR-DemiLight.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./../font/NotoSansKR-DemiLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./../font/NotoSansKR-DemiLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./../font/NotoSansKR-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./../font/NotoSansKR-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./../font/NotoSansKR-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./../font/NotoSansKR-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./../font/NotoSansKR-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./../font/NotoSansKR-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./../font/NotoSansKR-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./../font/NotoSansKR-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./../font/NotoSansKR-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./../font/NotoSansKR-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./../font/NotoSansKR-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./../font/NotoSansKR-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./../font/Pretendard-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./../font/Pretendard-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./../font/Pretendard-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./../font/Pretendard-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./../font/Pretendard-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./../font/Pretendard-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("./../font/Pretendard-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("./../font/Pretendard-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("./../font/Pretendard-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("./../font/Pretendard-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("./../font/Pretendard-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("./../font/Pretendard-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/* font */
@font-face {
  font-family: "Urbanist";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:
    local("Urbanist-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}

@font-face {
  font-family: "Urbanist";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src:
    local("Urbanist-SemiBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src:
    local("NotoSansKR-Thin"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  src:
    local("NotoSansKR-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 350;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src:
    local("NotoSansKR-DemiLight"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src:
    local("NotoSansKR-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src:
    local("NotoSansKR-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  src:
    local("NotoSansKR-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff");
}

@font-face {
  font-family: "NotoSansKR";
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src:
    local("NotoSansKR-Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff");
}
/* 250424 추가 [s] */
@font-face {
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 300;
  src:
    local("Pretendard Thin"),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  src:
    local("Pretendard Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  src:
    local("Pretendard Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 600;
  src:
    local("Pretendard SemiBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  src:
    local("Pretendard Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  src:
    local("Pretendard ExtraBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff");
  font-display: swap;
}
/* 250424 추가 [e] */
`, "",{"version":3,"sources":["webpack://./static/css/font.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,SAAS;AACT;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4CAAyC;EACzC;;;0DAGsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA2C;EAC3C;;;0DAGwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4CAAyC;EACzC;;;0DAGsD;AACxD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA0C;EAC1C;;;2DAGuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA8C;EAC9C;;;2DAG2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA4C;EAC5C;;;2DAGyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA2C;EAC3C;;;2DAGwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAAyC;EACzC;;;2DAGsD;AACxD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA0C;EAC1C;;;2DAGuD;AACzD;AACA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;;2DAGsD;EACtD,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;;2DAGyD;EACzD,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;;2DAGwD;EACxD,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;;2DAG0D;EAC1D,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;;2DAGsD;EACtD,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;;2DAG2D;EAC3D,kBAAkB;AACpB;AACA,kBAAkB","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/* font */\r\n@font-face {\r\n  font-family: \"Urbanist\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  src: url(\"./../font/Urbanist-Medium.eot\");\r\n  src:\r\n    local(\"Urbanist-Medium\"),\r\n    url(\"./../font/Urbanist-Medium.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Urbanist-Medium.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Urbanist\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  src: url(\"./../font/Urbanist-SemiBold.eot\");\r\n  src:\r\n    local(\"Urbanist-SemiBold\"),\r\n    url(\"./../font/Urbanist-SemiBold.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Urbanist-SemiBold.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  src: url(\"./../font/NotoSansKR-Thin.eot\");\r\n  src:\r\n    local(\"NotoSansKR-Thin\"),\r\n    url(\"./../font/NotoSansKR-Thin.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-Thin.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  src: url(\"./../font/NotoSansKR-Light.eot\");\r\n  src:\r\n    local(\"NotoSansKR-Light\"),\r\n    url(\"./../font/NotoSansKR-Light.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-Light.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 350;\r\n  src: url(\"./../font/NotoSansKR-DemiLight.eot\");\r\n  src:\r\n    local(\"NotoSansKR-DemiLight\"),\r\n    url(\"./../font/NotoSansKR-DemiLight.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-DemiLight.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src: url(\"./../font/NotoSansKR-Regular.eot\");\r\n  src:\r\n    local(\"NotoSansKR-Regular\"),\r\n    url(\"./../font/NotoSansKR-Regular.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-Regular.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  src: url(\"./../font/NotoSansKR-Medium.eot\");\r\n  src:\r\n    local(\"NotoSansKR-Medium\"),\r\n    url(\"./../font/NotoSansKR-Medium.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-Medium.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  src: url(\"./../font/NotoSansKR-Bold.eot\");\r\n  src:\r\n    local(\"NotoSansKR-Bold\"),\r\n    url(\"./../font/NotoSansKR-Bold.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-Bold.woff\") format(\"woff\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"NotoSansKR\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  src: url(\"./../font/NotoSansKR-Black.eot\");\r\n  src:\r\n    local(\"NotoSansKR-Black\"),\r\n    url(\"./../font/NotoSansKR-Black.woff2\") format(\"woff2\"),\r\n    url(\"./../font/NotoSansKR-Black.woff\") format(\"woff\");\r\n}\r\n/* 250424 추가 [s] */\r\n@font-face {\r\n  font-family: \"Pretendard\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  src:\r\n    local(\"Pretendard Thin\"),\r\n    url(\"./../font/Pretendard-Thin.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Pretendard-Thin.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Pretendard\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src:\r\n    local(\"Pretendard Regular\"),\r\n    url(\"./../font/Pretendard-Regular.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Pretendard-Regular.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Pretendard\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  src:\r\n    local(\"Pretendard Medium\"),\r\n    url(\"./../font/Pretendard-Medium.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Pretendard-Medium.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Pretendard\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  src:\r\n    local(\"Pretendard SemiBold\"),\r\n    url(\"./../font/Pretendard-SemiBold.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Pretendard-SemiBold.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Pretendard\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  src:\r\n    local(\"Pretendard Bold\"),\r\n    url(\"./../font/Pretendard-Bold.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Pretendard-Bold.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \"Pretendard\";\r\n  font-style: normal;\r\n  font-weight: 800;\r\n  src:\r\n    local(\"Pretendard ExtraBold\"),\r\n    url(\"./../font/Pretendard-ExtraBold.woff2\") format(\"woff2\"),\r\n    url(\"./../font/Pretendard-ExtraBold.woff\") format(\"woff\");\r\n  font-display: swap;\r\n}\r\n/* 250424 추가 [e] */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
